<template>
    <div class="card-text">
        <div class="d-flex my-3">
            <div class="text-info pr-2">Soluciones: <b-badge pill>{{ solutions }}</b-badge></div>
            <div class="text-danger pl-2">Rechazos: <b-badge pill>{{ rejections }}</b-badge></div>
        </div>
        <div class="d-flex my-2" v-for="log in logs" :class="{ 'text-danger': log.action === 'R', 'text-info': log.action === 'S', 'text-succes': log.action === 'A', 'text-success': log.action === 'A' }">
            <div class="log-date pr-3"><strong>{{ log.created_at | datetime }}</strong></div>
            <div class="log-info">{{ log.name }}</div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        logs: {
            type: Array,
            default: []
        }
    },
    computed: {
        rejections(){
            return this.logs.filter(log => log.action === 'R').length;
        },
        solutions(){
            return this.logs.filter(log => log.action === 'S').length;
        },
    }
}
</script>